import React from "react";
import {
  ImageEighteen,
  ImageNineteen,
  ImageSeventeen,
  ImageTwenty,
} from "../assets/images";

const SevenTab = () => {
  const sections = [
    {
      title: "Meal plans tailored for chemotherapy and post-treatment healing",
      desc: "Designed with recovery needs in mind.",
      img: ImageSeventeen,
    },
    {
      title: "Personalized taste-aware recovery nutrition",
      desc: "Meals built around preferences without compromising healing.",
      img: ImageEighteen,
    },
    {
      title: "Balance of strength & immunity",
      desc: "Nutrient-rich plans to restore body resilience.",
      img: ImageNineteen,
    },
    {
      title: "Holistic nourishment & long-term wellness",
      desc: "Sustainable plans for life beyond treatment.",
      img: ImageTwenty,
    },
  ];

  return (
    <div className="w-full min-h-screen bg-white px-4 py-8">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-6 leading-snug">
            Nutritional Recovery <span className="text-green-700">&</span>{" "}
            Coaching
          </h1>
          <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Personalized, taste-aware nutrition to restore strength and balance
            during and after treatment.
          </p>
        </div>

        {/* Dynamic Sections */}
        <div className="space-y-16">
          {sections.map((section, index) => (
            <div
              key={index}
              className={`flex flex-col items-center gap-8 lg:gap-16 ${
                index % 2 === 1 ? "lg:flex-row-reverse" : "lg:flex-row"
              }`}
            >
              {/* Image */}
              <div className="flex-shrink-0">
                <img
                  src={section.img}
                  alt={section.title}
                  className="w-56 h-56 md:w-64 md:h-64 object-contain"
                />
              </div>

              {/* Text */}
              <div className="flex-1 space-y-4 md:space-y-6 text-center lg:text-left">
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800">
                  {section.title}
                </h2>
                <p className="text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed">
                  {section.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
      </div>
      <div className="flex justify-center">
        <div
          className="mt-20 px-6 py-8 text-center"
          style={{
            backgroundColor: "#3a7e68",
            borderTopLeftRadius: "1.5rem",
            borderTopRightRadius: "1.5rem",
            display: "inline-block",
          }}
        >
          <p className="text-lg md:text-xl lg:text-2xl text-white font-medium max-w-3xl mx-auto leading-relaxed">
            Because food is not just nutrition—it’s healing, culture, and
            comfort.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SevenTab;
